import { PDFDocument } from "pdf-lib";
import { createOpenAIChatCompletion } from "../../../../services/openaiFunctions";

function fileToArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export async function uploadImagesToGoogleVision(images) {
  const apiKey = "AIzaSyB4Y74-eAmm052hOipuN9ky8RsnLEf1_u0";
  const url = `https://vision.googleapis.com/v1/images:annotate?key=${apiKey}`;

  const requests = images.map((base64Image) => ({
    image: { content: base64Image },
    features: [{ type: "TEXT_DETECTION" }],
  }));

  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ requests }),
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) throw new Error("Failed to contact Google Vision API");
    const data = await response.json();
    return data.responses; // This contains the processed data
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
}

export async function parseMenuWithOpenAI(extractedText) {
  const messages = [
    {
      role: "system",
      content: generatePrompt(extractedText),
    },
  ];

  const params = {
    model: "gpt-4",
    messages: messages,
    temperature: 1,

    top_p: 1,
    frequency_penalty: 0,
    presence_penalty: 0,
  };

  const maxRetries = 1;

  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      const data = await createOpenAIChatCompletion<any>(params);
      if (data && data.choices && data.choices.length > 0) {
        const completion = data.choices[0].message.content;
        console.log("Parsed Menu JSON:", completion);
        return parseJSONfromText(completion); // Or parse this as JSON if needed: JSON.parse(completion)
      }

      // If response doesn't have the expected format or is empty, retry
      throw new Error("Invalid response format or empty completion.");
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown OpenAI error";
      console.error(`Attempt ${attempt + 1} failed:`, errorMessage);

      // Max retries reached, handle accordingly or throw
      console.error("Failed to parse menu with OpenAI after maximum retries.");
      throw error; // Or handle this more gracefully
    }
  }
}
function generatePrompt(extractedText) {
  return `
Please format the following extracted text into a JSON object containing an array of plans, each with nested arrays of day plans and daily steps. The JSON structure should follow this format:

[
  {
    "id": "Unique and random UID string" (ex. SDJ43SDFXS),
    "title": "string",
    "shortDescription": "string",
    "description": "string",
    "categoryId": "string",
    "dayPlans": [
      {
        "id": "Unique and random ID string",
        "title": "string",
        "description": "string",
        "position":"number",
        "steps": [
          {
            "id": "Unique and random ID string",
            "title": "string",
            "subtitle": "string",
            "sectionTitle": "string",
            "description": "string",
            "text": "string",
            "reference": "string",
            "dayPlanID": "string",
            "planID": "string",
            "position": "number",
            "authorName": "string"
          }
        ],
        "planID": "string"
      }
    ],
    "stepsCount": number,
    "level": "string",
    "tags": ["string"]
  }
]

Formatting instructions:

1. Ensure all information from the extracted text is included in the JSON structure.
2. For each daily step's "text" field:
   - Provide detailed content that takes about 3-5 minutes to read.
   - Divide the text into multiple paragraphs for clarity and depth.
   - Use "\n\n" to separate paragraphs within the "text" string.
3. Generate appropriate values for all fields, including IDs, titles, descriptions, etc., based on the context of the extracted text.
4. The "stepsCount" should be a number, not a string.
5. The "tags" field should be an array of strings.
6. Write it as you were the author.
Here is the extracted text to format:

${extractedText}`;
}
export function parseJSONfromText(inputText) {
  // Detect whether the JSON is an object or an array
  const startObjectIndex = inputText.indexOf("{");
  const startArrayIndex = inputText.indexOf("[");

  // Determine the starting point and the type of JSON (object or array)
  let startIndex, startChar, endChar;
  if (
    (startObjectIndex !== -1 && startArrayIndex === -1) ||
    (startObjectIndex < startArrayIndex && startObjectIndex !== -1)
  ) {
    startIndex = startObjectIndex;
    startChar = "{";
    endChar = "}";
  } else if (startArrayIndex !== -1) {
    startIndex = startArrayIndex;
    startChar = "[";
    endChar = "]";
  } else {
    throw new Error("No JSON object or array start found.");
  }

  // Find the end index of JSON based on the start character
  const endIndex = inputText.lastIndexOf(endChar);
  if (endIndex === -1) {
    throw new Error(`No matching closing character for ${startChar} found.`);
  }

  // Extract the JSON string using the detected indices
  const jsonString = inputText.substring(startIndex, endIndex + 1);

  try {
    // Parse the JSON string
    const parsedJSON = JSON.parse(jsonString);
    return parsedJSON;
  } catch (error) {
    // Handle JSON parsing errors
    throw new Error("Invalid JSON data: " + error.message);
  }
}

/*
  
    ``Procese el texto del menú proporcionado "${extractedText}" para generar una matriz JSON estructurada, adecuada para todos los tipos de menú. Cada elemento de la matriz debe representar un elemento de menú único, encapsulado como un objeto que incluye los campos name, description (opcional), price (si está determinado), categoryName, y subsections (opcional). Su tarea principal es asegurar una representación precisa de todos los detalles del menú, especialmente para aquellos elementos que ofrecen variaciones o personalizaciones.
  
    Siga estas pautas detalladas para estructurar cada producto:
    
    name: Nombre del producto.
    description: Una descripción breve, si se proporciona.
    price: Precio del producto como valor numérico, o null si el precio varía basado en la selección de opciones.
    categoryName: La categoría del menú a la que pertenece el producto.
    subsections: Una matriz opcional que agrupa opciones o variaciones del producto principal bajo una pregunta o categoría común, como '¿Cómo lo quieres?'.
    Dentro de la única subsection para un producto, incluya:
    
    id: Un identificador único para la sección.
    name: Un nombre descriptivo para la sección que agrupa las opciones, ej., '¿Cómo lo quieres?'.
    includedQuantity: Número de ítems que se pueden elegir sin costo adicional.
    index: Posición de esta sección en relación con otras, si existieran más.
    isRequired: Indica si es obligatoria la selección de al menos una opción de esta sección.
    products: Una matriz de objetos, cada uno representando una opción específica dentro de la sección. Para cada opción, incluya id, name, y price. Asegúrese de que todas las opciones que pertenecen a una misma categoría de decisión estén agrupadas adecuadamente bajo esta subsection.
    Este enfoque debe garantizar que la salida JSON refleje de manera precisa y detallada el contenido completo del menú, facilitando la selección por parte del usuario final al agrupar opciones relacionadas bajo una categoría o pregunta común, y detallando claramente cada opción disponible, especialmente en términos de costos adicionales. ```
  
  
    */
